export default __webpack_public_path__ + "static/media/810.cb0aba30.png";